import { render, staticRenderFns } from "./InvestmentSearch.vue?vue&type=template&id=16aafcc2"
import script from "./InvestmentSearch.vue?vue&type=script&lang=js"
export * from "./InvestmentSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports